var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"column2Chart"},[(_vm.data&&_vm.data.jsonData)?_c('Line2Chart',{staticClass:"column2Chart",attrs:{"chartData":_vm.data.jsonData}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }